import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service/';
import { messages } from './messages';

export const WarehouseStatus = {
  id: 'warehouseStatus',
  type: OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER,
  filterValue: 'PickBatchStatusId',
  displayName: <FormattedMessage {...messages.warehouseStatus} />,
  expectsArgumentAsArray: false,

  render: (criteriaInformations) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_IS_RADIO_OPTIONS, criteriaInformations);
  },

  values: {
    NoStatus: 'NoStatus',
    ReadyToPick: 'ReadyToPick',
    Picking: 'Picking',
    Picked: 'Picked',
  },
};
